module.exports = __webpack_public_path__ + "media/bootstrap-icons/x-square-fill-667b2009.svg";